export default "__VITE_ASSET__BDEY6CW6__"